import { render, staticRenderFns } from "./sopTree.vue?vue&type=template&id=72762872&scoped=true&"
import script from "./sopTree.vue?vue&type=script&lang=js&"
export * from "./sopTree.vue?vue&type=script&lang=js&"
import style0 from "./sopTree.vue?vue&type=style&index=0&id=72762872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72762872",
  null
  
)

export default component.exports